import { Link, useLocation, useNavigate } from "react-router-dom";

const Breadcrumb = ({ overrideTrail }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("tab");
  const userNameFromState = location.state?.userName;
  const pathnames = location.pathname.split("/").filter(Boolean);
  const modifiedPathnames = pathnames[0] === "dashboard" ? pathnames.slice(1) : pathnames;

  const breadcrumbTrail = overrideTrail ?? location.state?.breadcrumbTrail ??
    modifiedPathnames
      .map((value, index) => {
        let fullPath = `/${pathnames.slice(0, index + 1).join("/")}`;
        if (value.toLowerCase() === "admin") {
          fullPath = "/admin/dashboard";
        }

        let displayName = value;
        if (value.toLowerCase() === "role" && activeTab === "permission") {
          displayName = "Permission";
        }
        if (!Number.isNaN(value) && userNameFromState && index === modifiedPathnames.length - 1) {
          displayName = userNameFromState;
        }
        // Handle formatting (optional: view-users -> View Users)
        displayName = displayName.replaceAll('-', ' ');
        return {
          name: displayName,
          path: fullPath,
        };
      })
      .filter(Boolean);

  return (
    <nav className="breadcrumb">
      {breadcrumbTrail.map((crumb, index) => {
        const isLast = index === breadcrumbTrail.length - 1;
        let finalName = crumb.name.toLowerCase() === "admin" ? "Dashboard" : crumb.name;
        if (isLast && finalName.length > 50) {
          console.log("Truncating breadcrumb:", finalName);
          finalName = finalName.slice(0, 50) + "...)";
        }

        return (
          <span key={crumb.path} className="pathSeparator">
            {index > 0 && " > "}
            {isLast ? (
              <span className="breadcrumb-active"><strong>{finalName}</strong></span>
            ) : (
              <Link
                to={crumb.path}
                className="breadcrumb-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(crumb.path, {
                    state: { breadcrumbTrail: breadcrumbTrail.slice(0, index + 1) },
                  });
                }}
              >
                {finalName}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
